<div class="display-[inherit] w-full">
  <div
    data-qa="message-box-container"
    [attr.data-qa-type]="type()"
    [class]="'box-border w-full border-solid border-0 border-l-8 rounded ' + boxClass()"
  >
    <div class="p-4 flex items-center gap-2">
      <mat-icon data-qa="message-box-icon" [svgIcon]="displayIcon()" [class]="iconClass()" />
      <!-- QA doc processes/tour-search-and-checkout-totals.md R-NR4a (website-web#110): any server text wraps to the box, even one long token -->
      <div data-qa="message-box-message" [class]="'min-w-0 wrap-anywhere font-medium ' + textClass()">
        {{ message() | translate }}
      </div>
    </div>
  </div>

  @if (traceId(); as traceId) {
    <div class="w-full flex justify-end items-center gap-1 relative right-[-5px]" data-testid="message-box-trace-id">
      <div
        class="text-kz-text-tertiary text-xs"
        data-qa="message-box-trace-id-label"
        data-testid="message-box-trace-id-label"
      >
        {{ 'Trace ID' | translate }}:
      </div>
      <div
        class="text-kz-text-tertiary text-xs break-all"
        data-qa="message-box-activity-id-text"
        data-testid="message-box-trace-id-text"
      >
        {{ traceId }}
      </div>
      <button
        type="button"
        mat-button
        class="min-w-3! p-1! text-kz-text-secondary! scale-70"
        data-qa="message-box-copy-button"
        data-testid="message-box-trace-id-copy-button"
        [attr.aria-label]="'Copy Trace ID to clipboard' | translate"
        [matTooltip]="'Copy Trace ID to clipboard' | translate"
        (click)="onCopyToClipboard(traceId)"
      >
        <mat-icon svgIcon="copy" class="m-0! w-4! h-4!" />
      </button>
    </div>
  }
</div>
